<form [formGroup]="addmeetingform" style="padding:20px;">
  <div class="row">
    <div class="col-lg-4 col-md-12 col-sm-8 form-group">
      <label for="meetingDate">
        Datum
      </label>
      <input type="text" class="form-control form-control-sm dateinput" mask="0000-00-00" formControlName="meetingDate" format="YYYY-mm-dd" id="meetingDate" placeholder="YYYY-MM-DD" style="width:110px;" required>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 form-group">
      <label for="issue">
        Rubrik
      </label>
      <input type="text" class="form-control form-control-sm" formControlName="issue" maxlength="30" id="issue" required>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 form-group">
      <label for="comment">
        Kommentar
      </label>
      <input type="text" class="form-control form-control-sm" formControlName="comment" id="comment">
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-lg-12 form-group">
      <mat-radio-group style="margin-left:0px;" aria-label="Mötestyp" formControlName="meetingTypeId" required>
        <mat-radio-button style="margin-left:2px;" value="1">Ordinarie</mat-radio-button>
        <mat-radio-button style="margin-left:2px;" value="2">Sommarmöte</mat-radio-button>
        <mat-radio-button style="margin-left:2px;" value="3">Övrigt möte</mat-radio-button>
      </mat-radio-group>
      <button class="btn border" style="max-width:75px;margin-left:20px;" (click)="addMeeting()" [disabled]="!addmeetingform.valid">Spara</button>
      <button class="btn border" style="max-width: 75px;margin-left: 10px;" (click)="close()">Avbryt</button>
    </div>
  </div>
  <br>
</form>
